import angular from 'angular';
import _ from 'lodash';

(function() {
  'use strict';
  angular.module('app.core').factory('SellerRelation', SellerRelationData);

  SellerRelationData.$inject = ['$translate', 'logger', '$filter', 'LegalEntity'];

  /* @ngInject */
  function SellerRelationData($translate, logger, $filter, LegalEntity) {
    SellerRelation.prototype = {
      build: build,
      buildEmpty: buildEmpty,
      getDematMode: getDematMode,
      getLadType: getLadType,
      getAllowedTransmissions: getAllowedTransmissions,
      getAllowedDemats: getAllowedDemats
    };

    function SellerRelation(sellerRelationData) {
      if (!sellerRelationData) {
        this.buildEmpty();
      } else {
        this.build(sellerRelationData);
      }
    }

    return SellerRelation;

    /////////////////////

    function buildEmpty() {
      this.principalName = null;
      this.buyer = new LegalEntity();
      this.acceptation = null;
      this.creationDate = null;
      this.endOfValidity = null;
      this.ladType = null;
      this.dematMode = null;
      this.allowedTransmissionChannels = null;
      this.allowedDematModes = null;
    }

    function build(relationData) {
      this.principalName = relationData.principalName || null;
      this.buyer = new LegalEntity(relationData.buyer);
      this.acceptation = relationData.acceptation ? $filter('date')(relationData.acceptation, 'shortDate') : null;
      this.endOfValidity = relationData.endOfValidity ? $filter('date')(relationData.endOfValidity, 'shortDate') : null;
      this.creationDate = relationData.creationDate ? $filter('date')(relationData.creationDate, 'shortDate') : null;
      this.ladType = relationData.ladType || null;
      this.dematMode = relationData.dematMode || null;
      this.allowedTransmissionChannels = relationData.allowedTransmissionChannels;
      this.allowedDematModes = relationData.allowedDematModes;
    }

    function getDematMode() {
      if (this.dematMode) {
        return translateDematMode(this.dematMode);
      }
      return '';
    }

    function getLadType() {
      if (this.ladType) {
        return translateLadType(this.ladType);
      }
      return '';
    }

    function getAllowedTransmissions() {
      var val = '';
      if (this.allowedTransmissionChannels) {
        val = _.map(this.allowedTransmissionChannels, function(trans) {
          return translateTransChannel(trans);
        }).join(' ou ');
      }
      return val;
    }

    function getAllowedDemats() {
      var val = '';
      if (this.allowedDematModes) {
        val = _.map(this.allowedDematModes, function(mode) {
          return translateDematMode(mode);
        }).join(' ou ');
      }
      return val;
    }

    function translateLadType(type) {
      return $translate.instant('principal.lad_types.' + angular.lowercase(type));
    }

    function translateDematMode(mode) {
      return $translate.instant('principal.demat_mode.' + angular.lowercase(mode));
    }

    function translateTransChannel(mode) {
      return $translate.instant('principal.transmission_mode.' + angular.lowercase(mode));
    }
  }
})();
